@if (category) {
  <div class="container bgr-white layout-row align-center text-center">
    <div class="layout-column spacer-top-16">
      <div class="layout-row align-center">
        <img class="category-icon spacer-right-16" [src]="category.marker" [alt]="category.slug" width="32px" height="32px">
        <h1>{{category.name}}</h1>
      </div>
      <p class="medium spacer-hr-16">{{category.description}}</p>
    </div>
  </div>
  <div class="container layout-row flex-wrap">
    @for (item of articlesInCategory; track item) {
      <div class="flex-half-tablet spacer-bottom-40">
        <div class="category-snippet">
          <gh-snippet-mobile [article]="item" class="snippet-wrapper"></gh-snippet-mobile>
        </div>
      </div>
    }
  </div>
  <gh-pagination [pager]="pager" type="category" [entity]="category" [currentPage]="currentPage"></gh-pagination>
  <div class="bgr-light-grey category-section">
    <gh-category-menu-section>
    </gh-category-menu-section>
  </div>
}
